angular
    .module('festzelt-os.modules.bo.options', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./routes');

// Controllers
require('./controllers/create-controller');
require('./controllers/details-controller');
require('./controllers/edit-controller');
require('./controllers/list-controller');

// Factories
require('./factories/option-factory');
require('./store/options');

// Workflows
require('./workflows/options-list/create-document-for-options');



// WEBPACK FOOTER //
// ./src/app/modules/bo/options/module.js